import { orchestrator } from 'satcheljs';
import { drawerPaneClosed } from 'owa-drawer';
import closeAppPane from './closeAppPane';
import getConfigurationByPaneId from '../utils/getConfigurationByPaneId';

orchestrator(drawerPaneClosed, ({ paneId, targetWindow }) => {
    const config = getConfigurationByPaneId(paneId);

    if (config) {
        closeAppPane(paneId, targetWindow);
        config.onDismiss?.();
    }
});
